import { css } from "@emotion/react";
import styled from "@emotion/styled";

import { setFullViewportWidthStyles, theme, transientOptions } from "shared/lib/styles";

import { Header } from "scmp-app/components/header";
import { HeaderOnelineMenuContainer } from "scmp-app/components/header/header-oneline-menu-container";
import { MegaMenuWrapper } from "scmp-app/components/header/header-oneline-menu-container/header-all-menu/styles";
import IconArrowNextMobile from "scmp-app/components/header/header-oneline-menu-container/header-oneline-menu/icon-arrow-next-mobile.svg?url";
import IconArrowNext from "scmp-app/components/header/header-oneline-menu-container/header-oneline-menu/icon-arrow-next.svg?url";
import IconArrowPreviousMobile from "scmp-app/components/header/header-oneline-menu-container/header-oneline-menu/icon-arrow-previous-mobile.svg?url";
import IconArrowPrevious from "scmp-app/components/header/header-oneline-menu-container/header-oneline-menu/icon-arrow-previous.svg?url";
import {
  StyledSwiper,
  StyledSwiperSlide,
} from "scmp-app/components/header/header-oneline-menu-container/header-oneline-menu/styles";
import { AllMenuContainer } from "scmp-app/components/header/header-oneline-menu-container/styles";
import { HeaderContainer as SharedHeaderContainer } from "scmp-app/components/header/styles";

export const HomeHeaderContainer = styled.section`
  > div {
    ${theme.breakpoints.up("desktop")} {
      padding-inline: 0;
    }
  }
`;

export const HeaderContainer = styled.div`
  position: relative;

  max-inline-size: 1208px;
  margin-inline: auto;

  background-color: transparent;

  ${theme.breakpoints.up("tablet")} {
    padding-block: 4px 0;
  }

  ${theme.breakpoints.up("desktop")} {
    padding-block: 1px 0;
  }
`;

export const Content = styled.div`
  position: relative;

  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;

  inline-size: 100%;
  block-size: 46px;
  box-sizing: border-box;

  ${theme.breakpoints.up("tablet")} {
    block-size: 100%;
  }
`;

export const LeftFeatureContainer = styled.div`
  display: flex;
  column-gap: 6px;
  align-items: center;
`;

export const CenterFeatureContainer = styled.div`
  display: flex;
  justify-content: center;
`;

export const RightFeatureContainer = styled.div`
  display: flex;
  flex-flow: row;
  gap: 20px;
  justify-content: flex-end;
  align-items: center;
`;

export const OnelineMenuContainer = styled.div`
  ${setFullViewportWidthStyles()}
  display: flex;
  justify-content: center;

  block-size: 36px;

  border-block-end: 1px solid #000000;

  ${theme.breakpoints.up("tablet")} {
    inset-inline: auto;

    inline-size: 100%;
    block-size: auto;
    margin-inline: 0;
  }

  ${theme.breakpoints.up("desktop")} {
    border-block-end: 1px solid #333333;
  }
`;

export const StyledHeaderOnelineMenuContainer = styled(HeaderOnelineMenuContainer)`
  display: flex;
  justify-content: center;
  align-items: center;

  margin-inline-start: 0;
  padding-block: 8px 12px;

  ${AllMenuContainer} {
    display: none;

    ${theme.breakpoints.up("desktop")} {
      display: flex;
    }
  }

  ${StyledSwiperSlide} {
    &:first-child {
      margin-inline-start: 20px;

      ${theme.breakpoints.up("tablet")} {
        margin-inline-start: 0;
      }
    }
    &:last-child {
      margin-inline-end: 20px;

      ${theme.breakpoints.up("tablet")} {
        margin-inline-end: 0;
      }
    }
    &:not(:last-child) {
      margin-inline-end: 16px;

      ${theme.breakpoints.up("desktop")} {
        margin-inline-end: 14px;
      }
    }
  }

  ${MegaMenuWrapper} {
    margin-block-start: 18px;
  }

  ${StyledSwiper} {
    .swiper-wrapper {
      block-size: auto;
    }

    .swiper-button-prev {
      margin-inline-start: -9px;

      background-image: url(${IconArrowPreviousMobile});

      ${theme.breakpoints.up("desktop")} {
        background-image: url(${IconArrowPrevious});
      }
    }

    .swiper-button-next {
      margin-inline-end: -9px;

      background-image: url(${IconArrowNextMobile});

      ${theme.breakpoints.up("desktop")} {
        background-image: url(${IconArrowNext});
      }
    }

    .swiper-button-prev,
    .swiper-button-next {
      inline-size: 36px;
      block-size: 17px;

      border-radius: 0;

      background-color: transparent;
      background-size: unset;

      opacity: 1;
    }
  }

  ${theme.breakpoints.up("tablet")} {
    padding-block: 20px 8px;
  }

  ${theme.breakpoints.up("desktop")} {
    padding-block: 8px 16px;
  }
`;

type StyledHomeMiniHeaderProps = {
  $appBarStickyScrollHeight?: number;
  $shouldSwap: boolean | null;
};

export const StyledHomeMiniHeader = styled(Header, {
  ...transientOptions,
})<StyledHomeMiniHeaderProps>`
  position: fixed;
  inset-block-start: -60px;

  background-color: #ffffff;

  ${props =>
    props.$shouldSwap === true
      ? css`
          inset-block-start: ${props.$appBarStickyScrollHeight ?? 0}px;

          transition: inset-block-start 0.4s;
        `
      : null}

  ${SharedHeaderContainer} {
    padding-block: 15px;
  }
`;
